import React from 'react'
import heroimage from '../assets/hero.jpg'
import {MdOutlineKeyboardArrowRight} from 'react-icons/md'
import {Link} from 'react-scroll'
import {Cursor,useTypewriter} from 'react-simple-typewriter'
const Home = () => {
  const [text]=useTypewriter({
    words:['Robotics Engineer'],
    loop:{},
    typeSpeed:180,
    deleteSpeed:100,
  });
  return (
    <div name="home" className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800">
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row md:gap-10"> 
        <div className="flex flex-col justify-center h-full">
          <h2 className="text-4xl sm:text-6xl font-bold text-white">
            I'm a {' '} 
            <span className="font-bold text-blue-500">
              {text}
            </span>
            <span className="text-red-600">
            <Cursor cursorStyle='<>'/>
            </span>
          </h2>
          <p className="text-gray-500 py-4 max-w-md text-justify">
          My passion for robotics is rooted in the fascinating convergence of Sensor Fusion, Motion Planning, SLAM, and AI, and how these elements combine to create intelligent, futuristic machines. This interest is further fueled by my belief that studying how living beings function and carefully analyzing their processes can lead to profound advancements in the field, opening new doors for innovation and discovery. The opportunities I’ve had at Piaggio Fast Forward and the Silicon Synapse Lab have been instrumental in shaping my journey, allowing me to apply my passion and knowledge in meaningful, impactful ways.
          </p>
          <div>
            <Link to="projects" smooth duration={500} className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer">
              Projects
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1"/>
              </span>
            </Link>
          </div>
        </div>
        <div>
          <img src={heroimage} alt='heroimage' className="rounded-2xl mx-auto w-2/3 md:w-full"/>
        </div>
      </div>
    </div>
  )
}

export default Home